import PropTypes from 'prop-types';
import React, { useEffect, useReducer } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { reducer } from '../../../utils/common';
import TooltipWrapper from '../tooltip/TooltipWrapper';
import Messaging from '../../../context/Messaging';

interface MenuItemProps {
  path?: string;
  text?: string;
  type?: string;
  disabled?: boolean;
}

function MenuItem({ path = '#0', text = '', type = 'promotional', disabled = false }: MenuItemProps) {
  function isSelected(link: string) {
    return localState?.currentUrl === link;
  }

  // React Router.
  const { pathname } = useLocation();

  // Local state.
  const [localState, setLocalState] = useReducer(reducer, {
    currentUrl: pathname,
  });

  // Listen for changes in routes to see if this menu item is selected.
  useEffect(() => {
    setLocalState({
      currentUrl: pathname,
    });
  }, [pathname]);

  const navLinkName = () => {
    if (path === '/') {
      return 'link-home';
    }
    const splitPath = path.split('/');
    return `link-${splitPath[splitPath.length - 1]}`;
  };

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e && e.preventDefault && e.preventDefault();
    }
  };

  return (
    <li
      className={`cb-nav-link ${type === 'procedural' ? 'cb-procedural' : 'cb-promotional'}`}
      data-automation={navLinkName()}
    >
      <NavLink
        id={navLinkName()}
        className={`${disabled ? 'cb-disabled' : ''} cb-menu-link ${isSelected(path) ? 'cb-selected' : ''}`}
        onClick={handleClick}
        to={path}
        aria-disabled={disabled}
        aria-describedby={disabled ? `${navLinkName()}-tooltip` : undefined}
      >
        <span>{text}</span>
      </NavLink>
      {disabled && (
        <TooltipWrapper trigger={navLinkName()} placement='right' tooltipId={`${navLinkName()}-tooltip`}>
          <span role='tooltip'>
            <Messaging dynamic preview section='defaultPreviewMessage' />
          </span>
        </TooltipWrapper>
      )}
    </li>
  );
}

MenuItem.propTypes = {
  external: PropTypes.bool,
  path: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string,
};

export default MenuItem;
